module.exports = __webpack_public_path__ + "static/media/online.f8eb39ea.svg";